export enum ProductPriceModeTagEnum {
  PriceAtOrAboveTarget = 'priceAtOrAboveTarget',
  LocallyManagedPrice = 'locallyManagedPrice',
  PassengerItem = 'passengerItem',
  CprAutoAssist = 'cprAutoAssist',
  Breakable = 'breakable',
  Contract = 'contract',
}
